<template>
    <!-- InvoiceSearchItem.vue -->
    <base-search-item :to="customerUrl" v-bind="$props"></base-search-item>
</template>

<script>
    import {INVOICE_ICON} from '@/store/static/base-icons'
    import {INVOICE} from '@/router/invoice/route-names'
    // Components
    import BaseSearchItem from './BaseSearchItem'

    export default {
        name: 'InvoiceSearchItem',
        extends: BaseSearchItem,
        components: {
            BaseSearchItem
        },
        props: {
            /**
             * The list item icon
             */
            icon: {
                type: String,
                default: INVOICE_ICON
            }
        },
        computed: {
            customerUrl () {
                const vm = this
                return {
                    name: INVOICE,
                    params: {
                        invoiceId: vm.item.id
                    }
                }
            }
        }
    }
</script>
